export const CONFIRM_SUBSCRIPTION_STEPS = {
  REVIEW: 'REVIEW',
  SELECT_CONTACT: 'SELECT_CONTACT',
  TOKEN_VALIDATION: 'TOKEN_VALIDATION',
}
